module.exports = __webpack_public_path__ + "img/谐和logo横.2bcfe444.png";